import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import axios from 'axios';

import { FCM } from '@capacitor-community/fcm';
// utils
import { default as appHelper } from './helper.capacitor';

const apiURL = appHelper.getBaseApiUrl();
axios.defaults.baseURL = apiURL;
const baseURL = apiURL;

import {
  useGetLocalUser
} from 'engine/Contexts/User.context';

//console.debug('info baseURL: ' + JSON.stringify(baseURL));

/* const logDeviceInfo = async () => {
  const info = await Device.getInfo();
  // console.debug('info: ' + JSON.stringify(info));
  return info;
};

const logDeviceId = async () => {
  const id = await Device.getId();
  // console.debug('info id: ' + JSON.stringify(id));
  return id;
}; */

const isPushNotificationsAvailable = Capacitor.isPluginAvailable(
  'PushNotifications',
);

const registerToken = async (token) => {
  const local = localStorage.getItem('schoolinked_user');
  const localUser = !!local && JSON.parse(local);
  console.debug('app run registerToken', localUser?._id)
  // Get FCM token instead the APN one returned by Capacitor
  let FCM_TOKEN = await FCM.getToken().then(r => r.token);

  if (appHelper.isAndroid) {
    console.debug('is android then : switch token APN');
    FCM_TOKEN = token?.value;
  }

  // get the device id
  const uuid = await Device.getId().then(result => result.uuid);
  // update the user with the corresponding token + uuid
  try {
    const res = await axios.post(
      baseURL + 'auth/register',
      {
        _id: localUser?._id,
        token: FCM_TOKEN,
        uuid: uuid,
        fcm_token: FCM_TOKEN || '',
      },
    );
    console.debug('res of auth/register', JSON.stringify(res))
  } catch (err) { 
    console.debug('auth/register error', JSON.stringify(err));
  }
}

// Get FCM token instead the APN one returned by Capacitor
const registerPush = async userId => {
  // external required step
  console.debug('app run registerPush');
  // register for push
  await PushNotifications.requestPermissions();
  await PushNotifications.register();

  // Enable the auto initialization of the library
  FCM.setAutoInit({ enabled: true }).then(() =>
    console.log(`Auto init enabled`),
  );

  // Check the auto initialization status
  FCM.isAutoInitEnabled().then(r => {
    console.log('Auto init is ' + (r.enabled ? 'enabled' : 'disabled'));
  });

  // listener on registration accept for push
  PushNotifications.addListener('registration', async token => {
    await registerToken(token);
  });

};

export default {
  isPushNotificationsAvailable,
  registerPush,
  registerToken,
}